import { render, staticRenderFns } from "./XueYangAdd.vue?vue&type=template&id=1832b582&scoped=true&"
import script from "./XueYangAdd.vue?vue&type=script&lang=js&"
export * from "./XueYangAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832b582",
  null
  
)

export default component.exports